<div class=" mt-4">
  <section>
    <div class="row">
      <div class="col-md-10">
        <div class="float-right">
          <button class="btn dash-btns mr-3" [routerLink]="['/pos/ordertype/new']">New Order Type</button>
          <button class="btn dash-btns" [routerLink]="['/pos/ordertype/manage']">Manage Order Type</button>
        </div>
      </div>
    </div>

  </section>
  <section class="mt-3">
    <div class="">
      <div class="row">
        <div class="col-md-7">
          <div class="card-1">
            <div class="row">
              <div class="col-md-12">
               
                <div class="text-center">
                  <a class="view-h gary-t">View Order Type</a>
                </div>

                <div class="pt-3">
                  <div class=" ">
                    <div class="row  mb-3">
                      <div class="col-4 p-0 label1"> Id</div>
                      <div class="col-7 p-0 view-text">{{rows.id}}</div>
                    </div>
                    <div class="row  mb-3">
                      <div class="col-4 label1 p-0"> Order Type</div>
                      <div class="col-7 p-0 view-text">{{rows.orderType}}</div>
                    </div>
                    <div class="row  mb-3">
                      <div class="col-4 label1  p-0">Default Order Type</div>
                      <div class="col-7 p-0 view-text">
                        <input type="checkbox" [(ngModel)]="rows.defaultOrderType" id="DefaultOrderType"
                          name="DefaultOrderType" [disabled]="!editable"/>
                      </div>
                    </div>
                    <div class="row  mb-3">
                      <div class="col-4 p-0 label1">PosSubscription Id</div>
                      <div class="col-7 p-0 view-text">{{rows.posSubscriptionId}}</div>
                    </div>
                    <div class="text-right pt-2">
                      <button class="dash-btns btn" id="accountDataList"
                        [routerLink]="['/pos/ordertype/manage']">Back</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5">
           <div class="text-center mb-5">
              <img src="assets/img/new/view-trans.svg" />
            </div>
        </div>
      </div>
    </div>
  </section>
</div>











<!-- 
<section class="content profile-page">
  <div class="block-header">
    <div class="container">
      <div class="row ">
        <div class="col-md-12  p-0">
          <h2 class="poppins font-weight-bold pl-2"> Order Type</h2>
        </div>
        <div class=" col-md-5 px-6 col-sm-12 p-0">

          <div class="breadcrumb flat">
            <a [routerLink]="['/pos']"> Home</a>
            <a [routerLink]="['/pos/ordertype/manage']">Manage Order Type</a>
            <a href="#" class="active"> View Order Type</a>
          </div>
        </div>
        <div class="col-md-7">
          <div class="float-right">
           
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="container">
    <div class="row">
      <div class="col-md-12 p-0">
        <div class=" card px-2 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
          <div class="row mx-0">
            <div class="col-md-12">
              <h4 class="font-weight-bold">View Order Type Details</h4>
            </div>
          </div>
          <div class="row mx-0">
           
            <div class="col-md-5">
              <div class="b">
                <img src="assets/img/payment-solutions.png" alt="Tips" style="display: block; width: 100%;">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->